<script lang="ts">
	import type { SvelteAsr } from 'types/common'
	import { hasPermission } from 'utility/permission'

	import Button from '@isoftdata/svelte-button'
	import Input from '@isoftdata/svelte-input'
	import Popover from '@isoftdata/svelte-popover'
	import StateCardHeader from 'components/StateCardHeader.svelte'
	import { onMount } from 'svelte'

	interface Props {
		asr: SvelteAsr
		searchKeyword?: string
	}

	let { asr, searchKeyword = $bindable('') }: Props = $props()

	let searchInput: HTMLInputElement | undefined = $state()

	onMount(() => searchInput?.focus())
</script>

<div class="card">
	<StateCardHeader
		icon="user"
		title="Customer Search"
	>
		{#snippet right()}
			{#if hasPermission('CUSTOMERS_CAN_ADD')}
				<Button
					outline
					size="sm"
					color="success"
					iconClass="plus"
					href={asr.makePath('app.customer')}
				>
					New Customer
				</Button>
			{/if}
		{/snippet}
	</StateCardHeader>
	<div class="card-body">
		<form
			id="search-field-form"
			onsubmit={(e) => {
				e.preventDefault()
				asr.go('app.customer-search.results', { keyword: searchKeyword })
			}}
		>
			<Input
				size=""
				showLabel={false}
				labelParentClass="mb-0"
				placeholder="Keyword Search"
				bind:input={searchInput}
				bind:value={searchKeyword}
			>
				{#snippet append()}
					<!-- Had to manually apply the rounded border radius, there are two "component" in the append slot here (button and popover) -->
					<Popover
						outline
						autoUpdate
						color="secondary"
						iconClass="info-circle"
						style="border-top-right-radius: 0.2rem; border-bottom-right-radius: 0.2rem;"
					>
						{#snippet content()}
							<h6 class="popover-header">Search Filters By:</h6>
							<div class="popover-body">
								<ul class="mb-0 pl-3">
									<li class="text-nowrap">Company Name</li>
									<li class="text-nowrap">Contact Name</li>
									<li class="text-nowrap">Phone Number</li>
								</ul>
							</div>
						{/snippet}
					</Popover>
				{/snippet}
			</Input>
		</form>
	</div>

	<div class="card-footer d-flex justify-content-end border-bottom">
		<Button
			type="submit"
			form="search-field-form"
			iconClass="search"
			size="sm"
		>
			Search Customers
		</Button>
	</div>
</div>

<uiView></uiView>
